export const UPSERT_MATCH = "UPSERT_MATCH";
export const BATCH_UPSERT_MATCHES = "BATCH_UPSERT_MATCHES";
export const UPSERT_GUARANTEE = "UPSERT_GUARANTEE";
export const BATCH_UPSERT_GUARANTEES = "BATCH_UPSERT_GUARANTEES";
export const UPSERT_NOTE = "UPSERT_NOTE";
export const BATCH_UPSERT_NOTES = "BATCH_UPSERT_NOTES";
export const SET_SELECTED_MATCHING_POSITION = "SET_SELECTED_MATCHING_POSITION";
export const SET_APPLICANT_VIEW_MODE = "SET_APPLICANT_VIEW_MODE";
export const SET_UPDATED = "SET_UPDATED";
